import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "content-image-preview" */'./ContentImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('content-image-preview')),
  LoadingComponent: () => null
});